export const fmtCurrency = (v) => {
  const n = Number(v || 0);
  if (Math.abs(n) >= 10000000) return `₹${(n / 10000000).toFixed(2)}Cr`;
  if (Math.abs(n) >= 100000) return `₹${(n / 100000).toFixed(2)}L`;
  return `₹${n.toLocaleString("en-IN")}`;
};

export const fmtNumber = (v) => Number(v || 0).toLocaleString("en-IN");

export const fmtValue = (v, format) => {
  if (format === "currency") return fmtCurrency(v);
  if (format === "percent") return `${Number(v || 0)}%`;
  return fmtNumber(v);
};

export const RAG = {
  green: { bg: "bg-emerald/10", text: "text-emerald", dot: "bg-emerald", label: "On Target" },
  amber: { bg: "bg-gold/10", text: "text-gold", dot: "bg-gold", label: "At Risk" },
  red: { bg: "bg-rose/10", text: "text-rose", dot: "bg-rose", label: "Below Target" },
  grey: { bg: "bg-slate/10", text: "text-slate", dot: "bg-slate", label: "No Target" },
};

export const STATUS_COLORS = {
  Connected: "text-emerald bg-emerald/10",
  "Not Reachable": "text-slate bg-slate/10",
  "Call Back Requested": "text-gold bg-gold/10",
  "Not Interested": "text-rose bg-rose/10",
  Yes: "text-emerald bg-emerald/10",
  No: "text-slate bg-slate/10",
  Active: "text-emerald bg-emerald/10",
  Inactive: "text-slate bg-slate/10",
  Achieved: "text-emerald bg-emerald/10",
  Missed: "text-rose bg-rose/10",
  Revised: "text-gold bg-gold/10",
  Running: "text-emerald bg-emerald/10",
  Upcoming: "text-gold bg-gold/10",
  Completed: "text-slate bg-slate/10",
  Cancelled: "text-rose bg-rose/10",
  "Agreement Signed": "text-emerald bg-emerald/10",
  "In Discussion": "text-gold bg-gold/10",
  Contacted: "text-slate bg-slate/10",
};

export const AI_MODELS = [
  { value: "gpt-5.4", label: "GPT-5.4 (OpenAI)" },
  { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
  { value: "gemini-3-flash-preview", label: "Gemini 3 Flash" },
];
